var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconTargetgroupEducators24 = function SvgAIconTargetgroupEducators24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 7.5C7.15685 7.5 8.5 6.15685 8.5 4.5C8.5 2.84315 7.15685 1.5 5.5 1.5C3.84315 1.5 2.5 2.84315 2.5 4.5C2.5 6.15685 3.84315 7.5 5.5 7.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5V13.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 22.5L8.5 15H10V12C10 9.51472 7.98528 7.5 5.5 7.5C3.01472 7.5 1 9.51472 1 12V15H2.5L3.25 22.5H7.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.5H21.5C22.3284 14.5 23 13.9883 23 13.3571V3.64286C23 3.01167 22.3284 2.5 21.5 2.5H11",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconTargetgroupEducators24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS41IDcuNUM3LjE1Njg1IDcuNSA4LjUgNi4xNTY4NSA4LjUgNC41QzguNSAyLjg0MzE1IDcuMTU2ODUgMS41IDUuNSAxLjVDMy44NDMxNSAxLjUgMi41IDIuODQzMTUgMi41IDQuNUMyLjUgNi4xNTY4NSAzLjg0MzE1IDcuNSA1LjUgNy41WiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTUuNSA3LjVWMTMuNSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljc1IDIyLjVMOC41IDE1SDEwVjEyQzEwIDkuNTE0NzIgNy45ODUyOCA3LjUgNS41IDcuNUMzLjAxNDcyIDcuNSAxIDkuNTE0NzIgMSAxMlYxNUgyLjVMMy4yNSAyMi41SDcuNzVaIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTMuNSAxNC41SDIxLjVDMjIuMzI4NCAxNC41IDIzIDEzLjk4ODMgMjMgMTMuMzU3MVYzLjY0Mjg2QzIzIDMuMDExNjcgMjIuMzI4NCAyLjUgMjEuNSAyLjVIMTEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";